import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import FAIcon from "../../UI/FAIcon/FAIcon";
const WidgetRefreshButton = (props) => {
    const button = (_jsx("button", { type: "button", className: classNames("btn btn-link d-flex justify-content-center align-items-center", {
            "ml-3 mr-1": !props.dontAddMargin,
            "p-0": !props.keepPadding,
        }, `text-${props.color || "muted"}`, props.className), 
        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
        disabled: props.isLoading || props.disabled, onClick: props.onRefresh, "aria-label": "Refresh", title: props.title || "Refresh", style: { textDecoration: "none" }, children: _jsx(FAIcon, { icon: "sync", spin: props.isLoading }) }));
    return props.title && props.disabled ? (_jsx("span", { title: props.title, children: button })) : (button);
};
export default WidgetRefreshButton;
